<template>
  <div class="orgDetail">
    <ZkKvItem :label="this.$t('enterprise.parentOrganizationCode')">{{
      currentOrg.parentOrganizationCode
    }}</ZkKvItem>
    <ZkKvItem :label="this.$t('enterprise.parentOrganizationName')">{{
      parentDept ? parentDept.organizationName : ''
    }}</ZkKvItem>
    <ZkKvItem :label="this.$t('enterprise.orgCode')">{{
      currentOrg.organizationCode
    }}</ZkKvItem>
    <ZkKvItem :label="this.$t('enterprise.orgName')">{{
      currentOrg.organizationName
    }}</ZkKvItem>
    <ZkKvItem :label="this.$t('common.lastupdateTime')">{{
      currentOrg.modifiedDateFormat
    }}</ZkKvItem>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  mounted () {},
  props: {
    currentOrg: {
      type: Object,
      default: function () {
        return {}
      }
    },
    parentDept: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      orgType: 'getOrgType'
    })
  },
  methods: {
    getOrgType (id) {
      let len = this.orgType.length
      for (let i = 0; i < len; i++) {
        let o = this.orgType[i]
        let oId = o.id
        if (id === oId) {
          return o.typeName
        }
      }
      return id
    }
  }
}
</script>

<style scoped lang="less">
.orgDetail {
  .kv_item_cla {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/orgStructure/orgInfoDeatil.vue